import React from 'react';
import { Outlet } from 'react-router-dom';
import SecurityDataProvider from './SecurityDataProvider';

const SecurityLayout = () => {
  return (
    <SecurityDataProvider>
      <div>
        <Outlet />
      </div>
    </SecurityDataProvider>
  );
};

export default SecurityLayout;